import appGlobalScript from '/home/cpilia/dev/projects/eproc-stencil-web-components/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
export const globalScripts = appGlobalScript;
